export class CompanyInventorySearch {
  id: string;
  name: string;
  skip: number = 0;
  limit: number = 10;
  totalItems: number = 0;
  active: Boolean;
  readjustmentIndex: Number;
  companyGroup: String[] = [];
//   industry: String[] = [];
  contractType: String[] = []
//   excellenceCenter: string[] = [];
  customer: string[] = [];

  newSearch(){
    let search = {

        // industry:this.industry,
        active:this.active,
        customer:this.customer,
        readjustmentIndex:this.readjustmentIndex,
        // excellenceCenter:this.excellenceCenter,
        companyGroup:this.companyGroup,
        contractType:this.contractType,
        skip:this.skip,
        limit:this.limit,
        totalItems:this.totalItems,
    };

    return search;
}

}



// WEBPACK FOOTER //
// ./src/app/models/CompanyInventorySearch.ts